import React, { useState } from "react";
import "./styles.scss";
import { followUser, unfollowUser } from "./../../../../api/users";
import { isSelfId } from "./../../../../api/helper";
import { log_error } from "../../../../api";
import HvButton from "../../shared/HvButton";
import { Spinner } from "react-bootstrap";
import _ from "lodash";

export default ({ user, className, varient = "primary" }) => {
  const [isFollowed, setIsFollowed] = useState(user && !!user.is_followed);
  const onFollowUser = async () => {
    try {
      setIsFollowed(null);
      await followUser(user && user.id);
      setIsFollowed(true);
    } catch (error) {
      log_error(error);
    } finally {
    }
  };

  const onUnfollowUser = async () => {
    try {
      setIsFollowed(null);
      await unfollowUser({ user_id: user && user.id });
      setIsFollowed(false);
    } catch (error) {
      log_error(error);
    }
  };

  if (isSelfId(user.id)) {
    return null;
  }

  return isFollowed ? (
    <HvButton
      onClick={onUnfollowUser}
      className={`btn btn-${varient} is-followed buttons ${className}`}
    >
      <span>Following</span>
    </HvButton>
  ) : (
    <HvButton
      onClick={onFollowUser}
      className={`btn btn-${varient} not-followed buttons ${className}`}
    >
      Follow
    </HvButton>
  );
};
